import styled, { css } from 'styled-components';

import colors from '~/styles/colors';
import grid from '~/styles/grid';

interface RowDataProps {
  borderColor?: string;
}

export const Container = styled.div`
  margin-bottom: 56px;
`;

export const NoDataAvailable = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 40rem;
  margin: 0 auto;

  text-align: center;

  div {
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    padding: 1.1rem;
    width: 6.8rem;
    height: 6.8rem;
    border-radius: 50%;
  }

  p {
    font-size: 24px;
    margin: 1.7rem 0 0.5rem 0;
    color: #6c6c6c;
  }

  span {
    font-size: 16px;
    color: #6c6c6c;
  }
`;

export const RowData = styled.tr<RowDataProps>`
  svg {
    cursor: pointer;
    transition: ease-in all 0.2s;
    &:hover {
      color: ${colors.primary};
    }
  }

  td {
    &:last-child {
      text-align: center;
    }
    height: 4.2rem;
    font-size: 14px;
    color: ${colors.lightblack};
    text-align: left;

    span {
      display: block;
      font-size: 14px;

      ${(props) =>
        props.borderColor &&
        css`
          color: ${props.borderColor};
        `}
    }
  }
`;

export const FirstColumn = styled.td<RowDataProps>`
  width: 2.8rem;
  height: 20%
  padding: 0 !important;
  text-align: left;

  &:before {
    content: '';
    border-radius: 5px;
    padding-top: 0.7rem !important;
    padding-bottom: 0.7rem !important;

    ${(props) =>
      props.borderColor &&
      css`
        border-left: 5px solid ${props.borderColor};
      `}
  }
`;

export const Sortable = styled.button`
  display: flex;
  border: 0;
  font-size: 14px;
  font-family: 'Exo 2', sans-serif;
  font-weight: bolder;
  background: none;
  align-self: flex-end;
  color: #6c6c6c;

  svg {
    margin-left: 0.3rem;
  }
`;

export const CheckboxColumn = styled.td`
  width: ${grid.xxl};
  padding: 0;
`;
